export const trackEvent = (name, props = {}) => {
  if (typeof window !== "undefined" && window.posthog) {
    window.posthog.capture(name, props);
  }
};
